<template>
	<div class="section">
		<div class="container is-small">
			<div class="section-body">
				<div class="section-subtitle is-black">
					Sign up and start redirecting
				</div>
				<div class="section-subtitle is-small-thin">
					Direct your followers to the best shop choice based on their location
					with only one link.
				</div>
				<div class="section-items">
					<div class="item">
						<AppInput
							size="medium"
							placeholder="Your invitation code"
						/>
					</div>
					<div class="item">
						<router-link :to="{ name: 'Dashboard' }">
							<AppButton
								size="full"
								color="primary"
							>
								Sign in
							</AppButton>
						</router-link>
					</div>
					<div class="item">
						<p>Or</p>
					</div>
					<div class="item">
						<AppButton
							size="full"
							color="outline"
							item="icon"
						>
							<img
								src="@/assets/google.png"
								alt="google"
							>
							Sign in with your Google account
						</AppButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Signup',
};
</script>

<style lang="scss" scoped>
.section {
	.section-subtitle,
	.section-description {
		margin-bottom: $gap-2;
	}

	.section-body {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;

		.section-items {
			display: flex;
			flex-direction: column;

			.item {
				margin-top: $gap-3;

				&.button {
					margin-top: $gap-65;
				}
			}
		}

		p {
			width: 100%;
			display: flex;
			align-items: center;
			font-size: $size-6;
		}

		p:before {
			content: '';
			display: block;
			width: 100%;
			margin-right: $gap-2;
			height: 1px;
			background-color: $color-accent;
		}

		p:after {
			content: '';
			display: block;
			width: 100%;
			margin-left: $gap-2;
			height: 1px;
			background-color: $color-accent;
		}
	}
}

</style>
